(() => {
  const initStory = (root) => {
    if (!root || root.dataset.hhStoryReady === 'true') return;

    const slides = [...root.querySelectorAll('[data-hh-story-slide]')];
    const dots = [...root.querySelectorAll('[data-hh-story-dot]')];
    if (slides.length < 2) return;

    root.dataset.hhStoryReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const intervalMs = Number(root.dataset.hhStoryInterval) || 4200;
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer = null;

    const setActive = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      if (reduceMotion || slides.length < 2) return;
      stop();
      timer = window.setInterval(() => setActive(index + 1), intervalMs);
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        setActive(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    setActive(index);
    start();
  };

  const boot = () => {
    document.querySelectorAll('[data-hh-story]').forEach(initStory);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-hh-story]') || event.target;
    if (root?.matches?.('[data-hh-story]')) {
      root.dataset.hhStoryReady = 'false';
      initStory(root);
    }
  });
})();
